/* EOD Home: email signup (Nov 2026). Klaviyo subscribe form + background slideshow. */
if (!customElements.get('eod-signup')) {
  customElements.define('eod-signup', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type=email]');
      this.btn = this.querySelector('button');
      this.msg = this.querySelector('.eodh-sign__msg');
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      this.input.addEventListener('input', () => { this.input.removeAttribute('aria-invalid'); this.msg.textContent = ''; });
    }
    done() {
      this.classList.add('is-done');
      const d = this.querySelector('.eodh-sign__done');
      if (d) d.focus({ preventScroll: true });
    }
    async submit() {
      const email = this.input.value.trim();
      if (this.form.company.value) return this.done();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        this.input.setAttribute('aria-invalid', 'true');
        this.msg.textContent = 'Please enter a valid email address.';
        this.input.focus();
        return;
      }
      this.btn.disabled = true;
      const body = { data: { type: 'subscription', attributes: {
        custom_source: this.dataset.source || 'Website signup',
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }, relationships: { list: { data: { type: 'list', id: this.dataset.list } } } } };
      try {
        const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.company), {
          method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error(res.status);
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
        this.done();
      } catch (err) {
        this.msg.textContent = 'Something went wrong. Please try again in a moment.';
      } finally {
        this.btn.disabled = false;
      }
    }
  });
}

if (!customElements.get('eod-signup-slides')) {
  customElements.define('eod-signup-slides', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.eodh-sign__slide')];
      this.dots = [...this.querySelectorAll('.eodh-sign__dot')];
      this.i = 0;
      this.ms = Math.max(3, parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2) return;
      this.dots.forEach((d, n) => d.addEventListener('click', () => { this.go(n); this.restart(); }));
      this.visible = false;
      this.io = new IntersectionObserver((es) => { this.visible = es[0].isIntersecting; this.restart(); });
      this.io.observe(this);
      this.onVis = () => this.restart();
      document.addEventListener('visibilitychange', this.onVis);
      this.onSelect = (e) => {
        const n = this.slides.findIndex((s) => s.dataset.shopifyEditorBlock && s.dataset.shopifyEditorBlock.includes(e.detail.blockId));
        if (n > -1) { this.go(n); this.paused = true; this.restart(); }
      };
      this.onDeselect = () => { this.paused = false; this.restart(); };
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onDeselect);
    }
    disconnectedCallback() {
      clearInterval(this.t);
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this.onVis);
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onDeselect);
    }
    restart() {
      clearInterval(this.t);
      if (this.reduced || this.paused || !this.visible || document.hidden) return;
      this.t = setInterval(() => this.go((this.i + 1) % this.slides.length), this.ms);
    }
    go(n) {
      if (n === this.i) return;
      const prev = this.slides[this.i], next = this.slides[n];
      if (this.dataset.mode === 'slide') {
        next.style.transition = 'none';
        next.classList.remove('is-prev');
        void next.offsetWidth;
        next.style.transition = '';
        prev.classList.add('is-prev');
      }
      prev.classList.remove('is-active');
      next.classList.add('is-active');
      if (this.dots[this.i]) this.dots[this.i].classList.remove('is-active');
      if (this.dots[n]) this.dots[n].classList.add('is-active');
      this.i = n;
    }
  });
}